import * as React from "react";
const SvgArrowStylizedLg = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m23.65 14.75-9.417-9.416h3.535l9.783 9.782.906.906-.928.883-10.25 9.762h-3.624l9.887-9.417H2.667v-2.5H23.65Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgArrowStylizedLg;
